import type { ReactNode } from 'react';

const FIELDSET: React.CSSProperties = {
  border: 0,
  padding: 0,
  margin: 0,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
};

/**
 * A form body for a login that may not change it (SPEC §1.1L): a fieldset with
 * none of its own box that, when `readOnly`, disables every control inside and
 * draws the fields as text (`theme/readonly.css`). Editable, it is only the
 * column it lays out.
 */
export function ReadOnlyFieldset({ readOnly, children }: { readOnly: boolean; children: ReactNode }) {
  return (
    <fieldset disabled={readOnly} className={readOnly ? 'rr-readonly' : undefined} style={FIELDSET}>
      {children}
    </fieldset>
  );
}
